import React from 'react';
import { OverlayDrawerComponentProps } from '@sharefiledev/sharefile-appshell';

const LazyAddServiceContactsForClientsDrawer = React.lazy(
	() => import('../components/AddServiceContactsForClientsDrawer')
);
export const AddServiceContactsForClientsDrawer: React.FC<
	OverlayDrawerComponentProps<'urn:sfdrawer:client-mgt-pilet:service-contacts-multiple-clients:add'>
> = ({ piral, options, cancelInteraction, completeInteraction }) => {
	if (!options || !options.clientRIDs) {
		return <div data-testid="add-service-contacts-for-clients-drawer-error" />;
	}

	return (
		<React.Suspense
			fallback={<div data-testid="loading-add-service-contacts-for-clients-drawer" />}
		>
			<LazyAddServiceContactsForClientsDrawer
				initialParameters={{
					clientRIDs: options?.clientRIDs,
					canAddPrimaryServiceContacts: options?.canAddPrimaryServiceContacts,
					piral,
					cancelInteraction,
					completeInteraction,
				}}
			/>
		</React.Suspense>
	);
};
